import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CalendarItemEnum } from 'src/app/models/enums/calendarItemType';
import { DataService } from '../../services/data.service';
import { ButtonStateService } from '../../services/button-state.service';

@Component({
  selector: 'app-share-button',
  templateUrl: './share-button.component.html',
  styleUrls: [
    './share-button.component.scss',
    './share-button.component.en.scss',
  ],
})
export class ShareButtonComponent implements OnInit {
  @Input() btnClass: string = 'btn-md';
  @Output() addToCalendarClick = new EventEmitter<CalendarItemEnum>();
  CalendarItemEnum = CalendarItemEnum;

  btnText: string = '';
  links: any[] = [];
  loaded: boolean = false;
  isButtonDisabled: boolean = false;

  constructor(
    private dataService: DataService,
    private buttonStateService: ButtonStateService
  ) {}

  ngOnInit() {
    this.btnText = this.dataService.shareBtnData.title;
    this.links = this.dataService.shareBtnData.icons;
    this.loaded = true;
    this.buttonStateService.isButtonDisabled$.subscribe((state) => {
      this.isButtonDisabled = state;
    });
  }

  getShareLink(type: CalendarItemEnum): any {
    return this.links.find((c) =>
      c.type.toLowerCase().includes(type.toString().toLowerCase())
    );
  }

  shareClick(event: any, type: CalendarItemEnum) {
    event.preventDefault();
    this.addToCalendarClick.emit(type);
  }
}
